import i18n, { Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translations from '@project44-ui/movement-translations';

import { defaultLang, supportedLangs } from './constants';
import { Language } from './types';
import { localeToLang } from './utils';

let isInitialized = false;

const initLanguageDetector = () => {
  const languageDetector = new LanguageDetector();
  languageDetector.addDetector({
    name: 'mwaLanguageDetector',
    lookup() {
      const userLanguages = navigator.languages || [navigator.language];
      const lang = userLanguages.find((lang) =>
        supportedLangs.includes(localeToLang(lang) as Language),
      );

      return localeToLang(lang);
    },
  });

  return languageDetector;
};

const prepareResources = (): Resource => {
  const resources: Resource = {};

  Object.entries(translations).forEach(([app, bundle]) => {
    const namespace = `@project44/${app.replace(/\_/g, '-')}`;

    supportedLangs.forEach((lang) => {
      if (!resources[lang]) resources[lang] = {};
      resources[lang][namespace] =
        (bundle as never)[lang] || (bundle as never)['en'];
    });
  });

  return resources;
};

export const i18nextInit = () => {
  if (isInitialized) return;

  i18n
    .use(initReactI18next)
    .use(initLanguageDetector())
    .init({
      resources: prepareResources(),
      detection: {
        order: ['cookie', 'mwaLanguageDetector'],
        lookupCookie: 'locale',
      },
    });

  i18n.changeLanguage(
    supportedLangs.includes(i18n.language as Language)
      ? i18n.language
      : defaultLang,
  );

  i18n.on('languageChanged', (lang) => (document.documentElement.lang = lang));
  document.documentElement.lang = i18n.language;
  isInitialized = true;
};

export const i18nextReset = () => {
  isInitialized = false;
};
